import { Component } from '@angular/core';
import { DigibankAgencyProvider } from '@internal-providers/digibank-agency.provider';
import { EventTypeProvider } from '@internal-providers/event-type.provider';
import { ICalendarAddressFilter } from '@shared-libs/interfaces';
import { NavigationService } from '@shared-services/navigation.service';
import { CalendarController } from '../calendar.controller';
import { UserPermissions } from '@shared-libs/enums';

@Component({
	selector: 'calendar-desktop-page',
	templateUrl: 'calendar.desktop.page.html',
	styleUrls: ['./calendar.desktop.page.scss'],
})
export class CalendarDesktopPage {
	public expandFilters: boolean = true;
	public eventTypes: Array<{ name: string; value: string }>;
	public digibankAgencies: Array<{ name: string; value: string }>;
	public showBeegoOptions: Array<{ name: string; value: boolean }>;

	public readonly UserPermissions: typeof UserPermissions = UserPermissions;

	constructor(
		public readonly controller: CalendarController,
		private readonly navigationService: NavigationService,
		private readonly eventTypeProvider: EventTypeProvider,
		private readonly digibankAgencyProvider: DigibankAgencyProvider
	) {
		this.navigationService.onNavigateToCurrentPage().subscribe(() => {
			this.handleCalendarPageEntry();
		});
	}

	private handleCalendarPageEntry(): void {
		this.getShowBeegoOptions();
		void this.getEventTypes();
		void this.getDigibankAgencies();
	}

	public toggleFilters() {
		if (this.expandFilters) {
			this.expandFilters = false;
		} else {
			this.expandFilters = true;
		}
	}

	public async onAddressFilter(calendarAddressFilter: ICalendarAddressFilter) {
		this.controller.getDisplayCalendarEvents(calendarAddressFilter);
	}

	public onSearchTermFilter(searchTerm: string): void {
		this.controller.getDisplayCalendarEvents({ searchTerm });
	}

	public onEventTypeFilter(eventTypes: Array<string>): void {
		this.controller.getDisplayCalendarEvents({ eventTypes });
	}

	public onDigibankAgencyFilter(agencies: Array<string>): void {
		this.controller.getDisplayCalendarEvents({ agencies });
	}

	public onShowBeegoFilter(beego: boolean): void {
		this.controller.getDisplayCalendarEvents({ beego });
	}

	/**
	 * Get show beego options (yes/no)
	 * formatted for the calendar select filter
	 */
	private getShowBeegoOptions(): void {
		this.showBeegoOptions = [
			{ name: 'YES', value: true },
			{ name: 'NO', value: false },
		];
	}

	/**
	 * Get the event types from the API
	 * formatted for the calendar select filter
	 */
	private async getEventTypes(): Promise<void> {
		this.eventTypes = (await this.eventTypeProvider.getAll()).map((eventType) => ({
			value: eventType.id,
			name: eventType.name,
		}));
	}

	/**
	 * Get the digibank agencies from the API
	 * formatted for the calendar select filter
	 */
	private async getDigibankAgencies(): Promise<void> {
		this.digibankAgencies = (await this.digibankAgencyProvider.getAll()).map((agency) => ({
			value: agency.id,
			name: agency.name,
		}));
	}
}
